/** Session key: after saving a new analysis from workflow, attach it to this dashboard id. */
export const POST_SAVE_ACTIVE_DASHBOARD_KEY = "reporting.postSaveDashboardId";
